<template>
  <div class="customer-type" :class="{ desktop: $isDesktop }">
    <translate tag="h1">How can we help you?</translate>
    <hr />
    <br />
    <translate tag="p">I am a...</translate>
    <div class="contact-buttons">
      <base-button css-class="primary" @click="onCustomerClick">
        <translate>Customer</translate>
      </base-button>
      <base-button css-class="secondary" @click="onSiteOwnerClick">
        <translate>Site owner</translate>
      </base-button>
      <base-button css-class="alt" @click="onOtherClick">
        <translate>Other</translate>
      </base-button>
    </div>
    <translate tag="p"
      >Please choose one of the options above so we can find the best way to
      help you.</translate
    >
  </div>
</template>

<script setup lang="ts">
const router = useRouter()

async function onCustomerClick() {
  await router.push({ params: { customerType: 'customer' } })
}

async function onSiteOwnerClick() {
  await router.push({ params: { customerType: 'manager' } })
}

async function onOtherClick() {
  await router.push({ params: { customerType: 'other' } })
}
</script>

<style scoped>
.contact-buttons {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 1em 0 3em;
  gap: 2em;
}

.contact-buttons button {
  font-weight: bold;
  font-size: 1.4em;
  margin: 0;
  width: 100%;
}

.desktop .contact-buttons {
  flex-direction: row;
  justify-content: flex-start;
}

.desktop .contact-buttons button {
  width: auto;
  min-width: 10em;
}
</style>
